/* 🤖 this file was generated by svg-to-ts */
export const iconXeth: {
  name: 'xeth';
  data: string;
} = {
  name: 'xeth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#okxwrappedeth__clip0_3302_130)"><path fill="#fff" d="M0 0h32v32H0z"/><path fill="currentColor" fill-rule="evenodd" d="M16 0c8.84 0 16 7.16 16 16s-7.16 16-16 16S0 24.83 0 16 7.16 0 16 0M4.71 27.29h22.58V4.71H4.71z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="m10 15.75 5.92 3.61 5.92-3.61L15.92 6zm0 1.01 5.92 8.54 5.92-8.54-5.92 3.54z" clip-rule="evenodd"/></g><defs><clipPath id="okxwrappedeth__clip0_3302_130"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
